import { useSelector } from 'react-redux';
import {
  isConsumerArea as selectIsConsumerArea,
  selectLanguagePreference,
} from '../../../CommonSelectors/CommonAreaSelector';
import { externalHostSelector as selectExternalHostSelector } from '../../../ConsumerArea/ConsumerAreaSelector';
import { EXTERNAL_HOST } from '../../../ConsumerArea/ConsumerAreaConstants';
import { isOptedIn } from '../../../CommonUtils/isOptedIn';
import { LanguageCode } from '../../../CommonSelectors/CommonArea.types';
import { useGoalsSummaryQuery } from '../../api/useGoalsSummaryQuery';

export const useShowDownloadPdf = () => {
  const queryInfo = useGoalsSummaryQuery();
  const isConsumer = useSelector(selectIsConsumerArea);

  const externalHost = useSelector(selectExternalHostSelector);

  const languagePreference = useSelector(selectLanguagePreference);

  const downloadPDFOptedIn = isOptedIn('DownloadPdf');

  return (
    isConsumer &&
    ![EXTERNAL_HOST.FTCI, EXTERNAL_HOST.ELEMENT].includes(externalHost) &&
    downloadPDFOptedIn &&
    (languagePreference === LanguageCode.EnglishAmerican || languagePreference === null) &&
    !!queryInfo.data
  );
};
